import * as mdijs from '@mdi/js'
import mdiVue from 'mdi-vue/v3'

export default {
  install(app: any) {
    app.use(mdiVue, {
      icons: mdijs,
    })
  },
}
